import { Component } from "./component";

export const Loading: React.FC = () => {
  return <Component />;
};